import { Controller } from '@hotwired/stimulus';

// Drives the thumb choice in the feedback modal; open-modal-by-id opens it and modal#handleSubmitEnd
// closes it after a successful send. Send stays disabled until a thumb is chosen.
export default class extends Controller {
  static targets = ['submit', 'error'];

  // A bar thumb: the choice is made, so Send takes focus and Enter submits.
  // Runs after open-modal-by-id#open, so focusing Send isn't undone by showModal's autofocus.
  select({ params: { value } }) {
    this.element.querySelector(`input[name="feedback[value]"][value="${value}"]`).checked = true;
    this.chosen();
    this.submitTarget.focus();
  }

  // A thumb picked inside the modal: focus stays put, so arrow keys and the comment box keep working.
  chosen() {
    this.submitTarget.disabled = false;
  }

  // Fires after the dialog has closed, so the browser's focus restore to the opener is already done
  // and focus can go back to the chat's message box. A dialog's close event doesn't bubble, hence the :capture.
  closed() {
    this.errorTarget.textContent = '';
    document.querySelector('#new_message textarea')?.focus();
  }

  clear() {
    this.element
      .querySelectorAll('input[name="feedback[value]"]')
      .forEach((input) => (input.checked = false));
    this.submitTarget.disabled = true;
  }
}
